import { FormikConfig } from 'formik'
import { SecretFormProps, SecretFormSchemaType } from './SecretForm.types'
import { getSlug } from '@/utils/slug'
import { useQueryClient } from '@tanstack/react-query'
import { yup } from '@knots/shared-frontend'
import { secretsQueries, useCreateSecret } from '@/features/secrets'

export const SecretFormSchema = yup.object().shape({
  name: yup.string().required().label('Name'),
  value: yup.string().required().label('Value'),
})

export const useSecretFormProps = ({ onCreated, projectId }: SecretFormProps): FormikConfig<SecretFormSchemaType> => {
  const queryClient = useQueryClient()
  const createSecret = useCreateSecret(projectId)

  return {
    initialValues: {
      name: '',
      value: '',
    },
    validationSchema: SecretFormSchema,
    onSubmit: async (values, { resetForm }) => {
      return createSecret.mutateAsync(
        {
          ...values,
          slug: getSlug(values.name),
        },
        {
          onSuccess: async (secret) => {
            await queryClient.invalidateQueries(secretsQueries.list(projectId))
            onCreated?.(secret)
            resetForm()
          },
        }
      )
    },
  }
}
